// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".option-list{display:flex;flex-direction:column;gap:12px;margin:8px 0}.option-item{padding:10px 1px}.session-availabilities-spacing{margin-top:8px;margin-bottom:8px;border-radius:6px}.session-availabilities-spacing label{display:flex;align-items:center;margin-bottom:8px;padding:6px 8px}.chk-error{color:#dc3545;font:normal normal 14px Ubisoft Sans}", ""]);
// Exports
module.exports = exports;
